var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrust(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.37416 5.14544L10.3901 0.941957C10.6322 0.796691 10.9299 0.796691 11.1721 0.941957L15.5909 3.58902C16.0352 3.85419 16.1152 4.48598 15.7531 4.86413L14.2557 6.42747C14.0069 6.68802 13.6181 6.74106 13.3115 6.55659L11.1788 5.27918C10.9322 5.13161 10.6278 5.13161 10.3812 5.27918L2.98315 9.75705V5.84871C2.98315 5.55818 3.132 5.29071 3.37416 5.14544Z",
    fill: "#FA8C16"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6065 16.4011L11.1699 19.0597C10.9277 19.205 10.63 19.205 10.3901 19.0597L3.37416 14.8562C3.132 14.711 2.98315 14.4435 2.98315 14.153V10.6089L6.59775 8.43457V11.9878C6.59775 12.2784 6.7466 12.5458 6.98876 12.6888L10.3901 14.7271C10.6322 14.8724 10.9299 14.8724 11.1699 14.7271L13.3226 13.4382C13.6292 13.2537 14.0158 13.3067 14.2646 13.5673L15.7664 15.126C16.1308 15.5019 16.0508 16.136 15.6065 16.4011Z",
    fill: "#262627"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrust);
export default __webpack_public_path__ + "static/media/crust.6aafd18e5aad7e31ef02d13deb7ef088.svg";
export { ForwardRef as ReactComponent };